import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@mui/material';
import React, { useState } from 'react';
import { Item } from '../utils/sharedTypes';

interface Props {
  // Item to link to
  itemToLink: Item;
  // Item name as it appears in API responses (usually lowercase)
  itemToLinkName: string;
  // Item title to appear in dialog title
  itemToLinkTitle: string;
  // Item id name as it appears in API responses
  itemToLinkIdName: string;
  itemUpdater: Function;
  dialogOpen: boolean;
  setDialogOpen: React.Dispatch<React.SetStateAction<boolean>>;
  tableCreator: (
    setItems: React.Dispatch<React.SetStateAction<Item[]>>
  ) => JSX.Element;
}

const LinkItemsDialog = ({
  itemToLink,
  itemUpdater,
  dialogOpen,
  setDialogOpen,
  tableCreator,
  itemToLinkName,
  itemToLinkIdName,
  itemToLinkTitle,
}: Props) => {
  const [selectedItems, setSelectedItems] = useState<Item[]>([]);
  const handleLink = async () => {
    for (const item of selectedItems) {
      await itemUpdater(
        {
          ...item,
          [itemToLinkName]: itemToLink,
          [itemToLinkIdName]: itemToLink.id,
        },
        item.id
      );
    }
  };
  const handleClose = () => {
    setDialogOpen(false);
  };
  return (
    <Dialog fullWidth maxWidth='xl' open={dialogOpen}>
      <DialogTitle>Select Items to Link to {itemToLinkTitle}</DialogTitle>
      <DialogContent>{tableCreator(setSelectedItems)}</DialogContent>
      <DialogActions>
        <Button
          color='primary'
          onClick={handleLink}
          disabled={selectedItems.length < 1}
        >
          Link Selected Items to {itemToLinkTitle}
        </Button>

        <Button color='error' onClick={handleClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LinkItemsDialog;
